import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles';
import _ from 'lodash'
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TableFooter from '@material-ui/core/TableFooter';

import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import {pending} from '../stores/State'
import Domain from '@material-ui/icons/Domain';

@inject('store')
@observer
class AccountInventoryLocations extends Component {

  handleRowClick(location){
    this.props.history.push(`/inventory_locations/${location.id}`);    
  }

  renderBodyRows(){
    const store = this.props.store.inventoryLocationStore;
    const uiStore = this.props.store.accountInventoryLocationsUIStore;        
    
    if(!store.inventoryLocations) return null;
    const start = uiStore.page*uiStore.rowsPerPage;
    const end = start + uiStore.rowsPerPage;
    
    const locations = store.inventoryLocations.slice(start, end)

    return locations.map(location => {

      return (
        <TableRow key={location.id} hover onClick={()=>this.handleRowClick(location)}>
          <TableCell>{location.customer.name}</TableCell>
          <TableCell>{location.name}</TableCell>
          <TableCell numeric>{(location.fill_rate*100).toFixed(0)}%</TableCell>
          <TableCell numeric>{location.inventory_count}/{location.capacity}</TableCell>
          <TableCell numeric>{location.inventory_weight} kg</TableCell>
        </TableRow>
      );
    })
  }

  renderHeaderRows(){
    return(
      <TableRow>
        <TableCell>Customer</TableCell>
        <TableCell>Location name</TableCell>
        <TableCell numeric>Fill rate</TableCell>
        <TableCell numeric>Inventory count</TableCell>
        <TableCell numeric>Inventory weight</TableCell>
      </TableRow>
    );
  }

  render() {
    const { classes } = this.props;
    const store  = this.props.store.inventoryLocationStore;    
    const uiStore = this.props.store.accountInventoryLocationsUIStore;        
    
    return (
      <Paper className={classes.paper}>
        <Typography className={classes.title} variant='subheading'><Domain/>All inventory locations</Typography>
        { store.inventoryLocationsState === pending && <CircularProgress /> }
        { store.inventoryLocations && 
          <Table className={classes.table}>
            <TableHead>
              {this.renderHeaderRows()}
            </TableHead>
            <TableBody>
              {this.renderBodyRows()}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={store.inventoryLocations.length}
                  rowsPerPage={uiStore.rowsPerPage}
                  page={uiStore.page}
                  onChangePage={(event, page)=>uiStore.setPage(page)}
                  onChangeRowsPerPage={(event)=>uiStore.setRowsPerPage(event.target.value)}
                />
              </TableRow>
            </TableFooter>
          </Table> }
        </Paper>
    );
  }
}


const styles = theme => ({
  paper: {
    padding: 20
  },
  title:{
    display: 'flex',
    alignItems: 'center'
  }
});

AccountInventoryLocations.propTypes = {
  accountId: PropTypes.number,
}
export default withRouter(withStyles(styles, {withTheme: true})(AccountInventoryLocations));



// WEBPACK FOOTER //
// ./src/components/AccountInventoryLocations.js